class UpdateBeneficiaryStaffMembers {
	constructor(
		public readonly facilityId: number,
		public readonly beneficiaryId: number,
		public readonly nursingStaffMemberId: number | null,
		public readonly homeCareStaffMemberId: number | null,
	) {
		Object.freeze(this);
	}

	// Both route identifiers stay out of the body. The server always expects both keys: an identifier
	// left unchanged is still sent, never omitted — omitting a key is a `400`, not a no-op (§7.7).
	toJSON(): Record<string, unknown> {
		return {
			nursingStaffMemberId: this.nursingStaffMemberId,
			homeCareStaffMemberId: this.homeCareStaffMemberId,
		};
	}
}

export default UpdateBeneficiaryStaffMembers;
